export default __webpack_public_path__ + "img/pci.6cce0390.svg";